import React from 'react';
import { Icon, IconSize, IconType } from '../Icon';
import { Header3Text, SmallBodyText } from '../Typography';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const StyledDropzoneArea = styled.div`
  align-items: center;
  border: dashed 1px ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.spacing.spacing5};
  display: flex;
  justify-content: center;
  padding: ${(props) => props.theme.spacing.spacing5};
`;

interface IUploadProps {
  onFileUpload: (file: File[]) => void;
  message?: React.ReactNode;
  multiple?: boolean;
}

export const Upload: React.FC<IUploadProps> = ({ onFileUpload, message, multiple }) => {
  const { getRootProps, getInputProps } = useDropzone({ onDrop: onFileUpload, multiple });
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledDropzoneArea>
        <Icon type={IconType.Upload} size={IconSize.Large} />
        <div>
          <Header3Text>Drag & Drop or click to browse</Header3Text>
          {message ? <SecondaryMessage>{message}</SecondaryMessage> : null}
        </div>
      </StyledDropzoneArea>
    </div>
  );
};

const SecondaryMessage = styled(SmallBodyText)`
  color: ${(props) => props.theme.colors.purple};
`;
